module.exports = __webpack_public_path__ + "static/media/final-page.9070fbea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/final-page.svg
// module id = 1843
// module chunks = 0